<template>
    <v-container fluid class="pa-0">
        <v-row dense>

            <v-col lg="3" md="6" cols="12">
                <stat-box
                        :value="stats.avg"
                        hint="Average"
                        :color="boxColor"
                        :loading="statsLoading"
                ></stat-box>
            </v-col>

            <v-col lg="3" md="6" cols="12">

                <stat-box
                        :value="stats.min"
                        hint="Minimum"
                        :color="boxColor"
                        :loading="statsLoading"
                ></stat-box>
            </v-col>

            <v-col lg="3" md="6" cols="12">
                <stat-box
                        :value="stats.max"
                        hint="Maximum"
                        :color="boxColor"
                        :loading="statsLoading"
                ></stat-box>
            </v-col>

            <v-col lg="3" md="6" cols="12">
                <stat-box
                        :value="stats.std_deviation"
                        hint="Standard deviation"
                        :color="boxColor"
                        :loading="statsLoading"
                ></stat-box>
            </v-col>

            <v-col lg="3" md="6" cols="12">
                <stat-box
                        :value="stats.std_deviation_bounds.upper"
                        hint="Standard deviation upper bound"
                        :color="boxColor"
                        :loading="statsLoading"
                ></stat-box>
            </v-col>

            <v-col lg="3" md="6" cols="12">
                <stat-box
                        :value="stats.std_deviation_bounds.lower"
                        hint="Standard deviation lower bound"
                        :color="boxColor"
                        :loading="statsLoading"
                ></stat-box>
            </v-col>

            <v-col lg="3" md="6" cols="12">
                <stat-box
                        :value="stats.variance"
                        hint="Variance"
                        :color="boxColor"
                        :loading="statsLoading"
                ></stat-box>
            </v-col>

            <v-col lg="3" md="6" cols="12">
                <stat-box
                        :value="stats.sum"
                        hint="Sum"
                        :color="boxColor"
                        :loading="statsLoading"
                ></stat-box>
            </v-col>

        </v-row>
    </v-container>
</template>

<script>

    import {mapActions} from 'vuex';
    import StatBox from '../../../../components/UI/StatBoxNumerical';

    export default {

        components: {
            StatBox
        },

        props: {
            dataVariable: {
                required: true,
                type: Object
            }
        },

        data() {
            return {
                statsLoading: false,
                stats: {
                    avg: 0,
                    min: 0,
                    max: 0,
                    std_deviation: 0,
                    std_deviation_bounds: {
                        upper: 0,
                        lower: 0,
                    },
                    variance: 0,
                    sum: 0
                },
                boxColor: 'blue-grey darken-1'
            }
        },

        mounted() {

            this.statsLoading = true;

            this.getDataVariableStats(this.dataVariable.id)
                .then(data => {
                    this.stats = data.stats;
                })
                .catch(() => {
                    Bus.$emit('flash-message', {
                        type: 'error',
                        message: 'Failed loading stored data count for the option!'
                    });
                })
                .finally(() => {
                    this.statsLoading = false;
                });
        },

        methods: {

            // Root actions
            ...mapActions([
                'getDataVariableStats'
            ]),

        }
    }
</script>
